/**
 * @generated SignedSource<<9220ba2e64d0f4174521bbd998b3abd1>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type JobTitle_job$fragmentType: FragmentType;
export type JobTitle_job$data = {|
  +build: ?{|
    +number: number,
    +pipeline: {|
      +name: string,
    |},
  |},
  +command: ?string,
  +label: ?string,
  +$fragmentType: JobTitle_job$fragmentType,
|};
export type JobTitle_job$key = {
  +$data?: JobTitle_job$data,
  +$fragmentSpreads: JobTitle_job$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobTitle_job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "command",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Build",
      "kind": "LinkedField",
      "name": "build",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Pipeline",
          "kind": "LinkedField",
          "name": "pipeline",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobTypeCommand",
  "abstractKey": null
};

(node/*: any*/).hash = "bb2a843c370f9aedfec40bc0e5d0a24d";

module.exports = ((node/*: any*/)/*: Fragment<
  JobTitle_job$fragmentType,
  JobTitle_job$data,
>*/);
